import { Injectable } from "@angular/core";
import { WebImageInfoRequest } from "../models";

import { ImagingClient } from "../models";

@Injectable({
  providedIn: "root"
})
export class ImagingService
{



  constructor(
    private imagingClient: ImagingClient
  )
  {

  }

  public getDocumentList(webImageInfoRequest: WebImageInfoRequest)
  {
    return this.imagingClient.getImageInfoForCustId(webImageInfoRequest)
  }
  public getDocument(image, branchNo)
  {
    return this.imagingClient.getImageInfoForDocument(image, branchNo);
  }
}
